// Copyright © Veeam Software Group GmbH

import React from 'react';
import { AppLayout } from '@veeam/components';

import type { FC } from 'react';

import { RestoreWizardsProvider } from 'components/Restore';
import { RbacContextProvider } from 'pages/ExplorePage/components/ScopesGrid';
import { MainAppBar } from './components/MainAppBar';
import { useRouting } from './useRouting';
import { ExploreTreeProvider } from 'pages/ExplorePage/contexts/ExploreTreeProvider';

export const Main: FC = () => (
    <RbacContextProvider>
        <ExploreTreeProvider>
            <AppLayout
                header={<MainAppBar />}
                body={(
                    <RestoreWizardsProvider>
                        {useRouting()}
                    </RestoreWizardsProvider>
                )}
            />
        </ExploreTreeProvider>
    </RbacContextProvider>
);
